import { 가족장2025 } from "./가족장";
import { 가족장프리미엄2025 } from "./가족장프리미엄";
import { 무빈소장2025 } from "./무빈소장";
import { 일반장2025 } from "./일반장";
import { 일반장프리미엄2025 } from "./일반장프리미엄";
// import { PremiumMemberShipPackage, 일반장프리미엄2025 } from "./일반장프리미엄";

// import { VIP장2025 } from "./VIP장";
// import { 매장무빈소장2025 } from "./burial/매장무빈소장";
// import { 매장가족장2025 } from "./burial/매장가족장";
// import { 매장일반장2025 } from "./burial/매장일반장";
// import { 매장VIP장2025 } from "./burial/매장VIP장";
import { Service2025Details } from "@/types/servicePackageType";

export const SERVICE_DETAILS_2025: Record<
  "가족장" | "일반장" | "무빈소장" | "가족장 프리미엄" | "일반장 프리미엄",
  Service2025Details
> = {
  무빈소장: 무빈소장2025,
  가족장: 가족장2025,
  ["가족장 프리미엄"]: 가족장프리미엄2025,
  일반장: 일반장2025,
  ["일반장 프리미엄"]: 일반장프리미엄2025,
};

// export const SERVICE_DETAILS_202406_1 = 가족장프리미엄202406;

// export const BURIAL_SERVICE_DETAILS_2024: Record<ServiceDetails["type"], ServiceDetails> = {
//   VIP장: 매장VIP장2024,
//   일반장: 매장일반장2024,
//   가족장: 매장가족장2024,
//   무빈소장: 매장무빈소장2024,
// };
